import React, { ComponentProps, ReactNode } from 'react';

import PropTypes from 'prop-types';

import ActivityCard from '../ActivityCard';
import ActivityValueChange from './ActivityValueChange';

type ValueChangeActivityCardProps = ComponentProps<typeof ActivityCard> & {
  before?: ReactNode;
  after: ReactNode;
};

/**
 * ValueChangeActivityCard component. Describes a generic single value change activity.
 */
const ValueChangeActivityCard = React.forwardRef<
  HTMLDivElement,
  ValueChangeActivityCardProps
>(({ before, after, ...props }, ref) => {
  return (
    <ActivityCard ref={ref} {...props}>
      <ActivityValueChange before={before} after={after} />
    </ActivityCard>
  );
});

ValueChangeActivityCard.displayName = 'ValueChangeActivityCard';

ValueChangeActivityCard.propTypes = {
  ...ActivityCard.propTypes,
  /** The value to render before change */
  before: PropTypes.node,
  /** The value to render after change */
  after: PropTypes.node.isRequired,
};

export default ValueChangeActivityCard;
